"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartView = exports.CartBody = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const CartProductView_1 = require("./CartProductView");
const components_1 = require("./CartView/components");
const __1 = require("../..");
const StoreNavActionsView_1 = require("../../storeNav/views/StoreNavActionsView");
function CartLoading() {
    return (0, jsx_runtime_1.jsx)(ui_1.LoadingOverlay, {});
}
function CartSuccess() {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(components_1.FlexWrap, { children: (0, jsx_runtime_1.jsx)(components_1.Title, Object.assign({ tag: "h2" }, { children: t('store.thankYouForPurchase') })) }));
}
function CartError() {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(components_1.FlexWrap, { children: (0, jsx_runtime_1.jsx)(components_1.Title, Object.assign({ tag: "h2" }, { children: t('error.purchaseProccesingProblem') })) }));
}
function CartEmpty() {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(components_1.FlexWrap, { children: [(0, jsx_runtime_1.jsx)(components_1.Title, { children: t('error.emptyCart') }), (0, jsx_runtime_1.jsx)(components_1.Description, { children: t('error.emptyCartDescription') })] }));
}
function CartViewContent({ cart, loading, error, success, noQuantity, productView: ProductView = CartProductView_1.CartProductView, }) {
    const { t } = (0, app_1.useTranslation)();
    if (error) {
        return (0, jsx_runtime_1.jsx)(CartError, {});
    }
    if (success) {
        return (0, jsx_runtime_1.jsx)(CartSuccess, {});
    }
    if (loading) {
        return (0, jsx_runtime_1.jsx)(CartLoading, {});
    }
    if (!cart || ((cart === null || cart === void 0 ? void 0 : cart.products.length) === 0 && (cart === null || cart === void 0 ? void 0 : cart.vouchers.length) === 0)) {
        return (0, jsx_runtime_1.jsx)(CartEmpty, {});
    }
    return ((0, jsx_runtime_1.jsxs)(components_1.CartContent, { children: [(0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: "/cart" }, { children: (0, jsx_runtime_1.jsx)(components_1.CartTitle, Object.assign({ tag: "h2" }, { children: t('store.myCart') })) })), (0, jsx_runtime_1.jsx)(ui_1.Stack, Object.assign({ list: true, kind: "vertical" }, { children: cart.products.map((product) => ((0, jsx_runtime_1.jsx)(ProductView, { product: product, noQuantity: noQuantity }, product.id))) }))] }));
}
function CartNavActions() {
    return (0, jsx_runtime_1.jsx)(StoreNavActionsView_1.StoreNavActionsView, { cartView: true });
}
function CartBody({ cart, total, loading, error, success, handleClose, onSubmit, noQuantity, productView, }) {
    const { t } = (0, app_1.useTranslation)();
    const [loadingInventory, setLoadingInventory] = (0, react_1.useState)(false);
    const { validateCart } = (0, __1.useCart)();
    const { push } = (0, app_1.useRouter)();
    const path = (0, app_1.useContextPath)('ecommerce.checkout');
    const totalFormatted = (total !== null && total !== void 0 ? total : 0) / 100;
    return ((0, jsx_runtime_1.jsx)(__1.SideBarLayoutView, Object.assign({ handleClose: handleClose, customHeader: CartNavActions }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CartViewContent, { cart: cart, loading: loading, error: error, success: success, noQuantity: noQuantity, productView: productView }), !loading && (cart === null || cart === void 0 ? void 0 : cart.products).length > 0 && ((0, jsx_runtime_1.jsxs)(components_1.FooterWrap, { children: [(0, jsx_runtime_1.jsxs)(components_1.DetailsWrap, { children: [(0, jsx_runtime_1.jsxs)(components_1.Detail, { children: [(0, jsx_runtime_1.jsx)(components_1.DetailName, { children: t('store.Products') }), (0, jsx_runtime_1.jsxs)(components_1.DetailPrice, { children: [totalFormatted, " ", cart.products[0].currency] })] }), (0, jsx_runtime_1.jsxs)(components_1.Detail, { children: [(0, jsx_runtime_1.jsx)(components_1.DetailName, { children: t('store.delivery') }), (0, jsx_runtime_1.jsx)(components_1.DetailPrice, { children: t('label.fromPrice', {
                                                price: '0.00 PLN',
                                            }) })] })] }), (0, jsx_runtime_1.jsxs)(components_1.Sum, { children: [(0, jsx_runtime_1.jsx)(components_1.DetailName, { children: t('store.Sum') }), (0, jsx_runtime_1.jsxs)(components_1.DetailPrice, { children: [totalFormatted, " ", cart.products[0].currency] })] }), (0, jsx_runtime_1.jsx)(components_1.PayButton, Object.assign({ loading: loadingInventory, onClick: () => {
                                setLoadingInventory(true);
                                void validateCart((hasErrors) => {
                                    setLoadingInventory(false);
                                    if (!hasErrors) {
                                        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
                                        void push(path);
                                    }
                                });
                            } }, { children: t('store.goToPaymentButton') }))] }))] }) })));
}
exports.CartBody = CartBody;
const drawerStyle = (0, app_1.css) `
  min-width: 25rem;
`;
exports.CartView = (0, react_1.forwardRef)((_a, ref) => {
    var { handleClose, sideBarProps, className } = _a, bodyProps = __rest(_a, ["handleClose", "sideBarProps", "className"]);
    return ((0, jsx_runtime_1.jsx)(ui_1.Drawer, Object.assign({ contentStyle: drawerStyle }, sideBarProps, { handleClickOutside: handleClose, className: className, ref: ref }, { children: (0, jsx_runtime_1.jsx)(CartBody, Object.assign({}, bodyProps, { handleClose: handleClose })) })));
});
